export default __webpack_public_path__ + "static/media/applause.b4ad612f.mp3";